import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { race, take } from 'rxjs';

import { TellentSecureChangeActions } from './tellent-secure-change.actions';

@Injectable({ providedIn: 'root' })
export class TellentSecureChangeService {
  public store = inject(Store);
  public actions$ = inject(Actions);

  public sendCode() {
    this.store.dispatch(TellentSecureChangeActions.sendCode());
  }

  public validateCode(code: string) {
    this.store.dispatch(TellentSecureChangeActions.validateCode({ code }));
    return race(
      this.actions$.pipe(ofType(TellentSecureChangeActions.validateCodeSuccess)),
      this.actions$.pipe(ofType(TellentSecureChangeActions.validateCodeFail)),
    ).pipe(take(1));
  }
}
